'use strict';
// @flow
const angular = require('angular');

interface User {
  name: string;
  email: string;
  role: string;
  password: string;
}

export default class SignupController {
  roles = ['shop', 'viewer', 'manager', 'admin'];
  user: User = {
    name: '',
    email: '',
    password: '',
    role: 'shop'
  };
  errors = {};
  submitted = false;
  Auth;
  $location;


  /*@ngInject*/
  constructor(Auth, $location) {
    this.Auth = Auth;
    this.$location = $location;

  }

  register(form) {
    this.submitted = true;

    if (form.$valid) {
      return this.Auth.createUser({
        name: this.user.name,
        email: this.user.email,
        role: this.user.role,
        password: this.user.password
      })
        .then(() => {
          this.goToAdminPage();
        })
        .catch(err => {
          err = err.data;
          this.errors = {};
          // Update validity of form fields that match the mongoose errors
          angular.forEach(err.errors, (error, field) => {
            form[field].$setValidity('mongoose', false);
            this.errors[field] = error.message;
          });

        });
    }
  }
  goToAdminPage(){
    this.$location.path('/userManagement');
  }
  validateField(form, name) {
    return {
      fieldRequired: form.$submitted && form[name].$error.required && form[name].$pristine,
      fieldInvalid: !form[name].$pristine && form[name].$invalid
    };
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/signup/signup.controller.ts